import map from 'lodash/map';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import uuidV4 from 'uuid/v4';
import {connect} from 'react-redux';
import serialize from 'form-serialize';
import Button from '@spothero/ui/button';
import Form from '@spothero/ui/form';
import FormElementError from '@spothero/ui/form-element-error';
import FormGroup from '@spothero/ui/form-group';
import FormGroupError from '@spothero/ui/form-group-error';
import Label from '@spothero/ui/label';
import Modal from '@spothero/ui/modal';
import ModalContent from '@spothero/ui/modal-content';
import Select from '@spothero/ui/select';
import TextInput from '@spothero/ui/text-input';
import CreditAPI from 'api/credit';
import SHUtils from 'utils/sh-utils';
import {notify} from 'notification/notification-actions';

class UpdateUserCreditModal extends Component {
    static propTypes = {
        userId: PropTypes.number.isRequired,
        credit: PropTypes.number.isRequired,
        onHidden: PropTypes.func.isRequired,
        onUpdated: PropTypes.func.isRequired,
        sendNotification: PropTypes.func.isRequired
    };
    state = {
        formError: null,
        isLoading: false,
        isLoadingReasons: true
    };

    constructor(props) {
        super(props);

        this._reasons = [{value: '', label: 'Please Select A Reason...'}];
    }

    componentDidMount() {
        this._loadReasons();
    }

    _onSubmit = evt => {
        this.setState({
            formError: null,
            isLoading: true
        });

        this._submitForm(serialize(evt.target, {hash: true}));
    }

    async _loadReasons() {
        try {
            const {
                data: {
                    data
                }
            } = await CreditAPI.getUpdateReasons();

            this._reasons = [
                ...this._reasons,
                ...map(data.results, ({description}, key) => {
                    return {
                        value: description,
                        label: description
                    };
                })
            ];
        } catch (error) {
            console.log('CreditAPI.getUpdateReasons() error:', error); // eslint-disable-line no-console
        }

        this.setState({
            isLoadingReasons: false
        });
    }

    async _submitForm({amount, reason}) {
        const {
            userId,
            onUpdated,
            sendNotification
        } = this.props;

        try {
            const {
                data: {
                    data
                }
            } = await CreditAPI.update({
                userId,
                amountChanged: amount,
                reason
            });

            sendNotification({
                id: uuidV4(),
                type: 'success',
                message: 'Credit updated successfully.'
            });

            onUpdated(data.spothero_credit);
        } catch (error) {
            if (error.data && error.data.data) {
                error.data = error.data.data;
            }

            sendNotification({
                id: uuidV4(),
                type: 'error',
                message: 'There was an issue updating credit, please try again.'
            });

            this.setState({
                formError: error.data.errors[0].messages[0],
                isLoading: false
            });
        }
    }

    render() {
        const {
            onHidden,
            credit
        } = this.props;
        const {
            isLoading,
            isLoadingReasons,
            formError
        } = this.state;

        return (
            <Modal
                className="UpdateUserCreditModal"
                title="Update Credit"
                width="slim"
                onHidden={onHidden}
            >
                <ModalContent>
                    <Form
                        id="UpdateUserCreditModal-form"
                        onSubmit={this._onSubmit}
                    >
                        <Label>Total Credit Amount: ${(credit !== 0) ? SHUtils.prettyPrice(credit) : '0'}</Label>
                        <FormGroup>
                            <TextInput
                                name="amount"
                                placeholder="0"
                                label={<Label>Add Credit Amount</Label>}
                                error={<FormElementError>Amount is required.</FormElementError>}
                                required
                                focus
                            />
                        </FormGroup>
                        <FormGroup>
                            <Select
                                name="reason"
                                items={this._reasons}
                                loading={isLoadingReasons}
                                disabled={isLoadingReasons}
                            />
                        </FormGroup>
                        {formError &&
                            <FormGroupError>{formError}</FormGroupError>
                        }
                        <div className="FormActions">
                            <Button
                                type="submit"
                                color="primary"
                                loading={isLoading}
                                disabled={isLoading}
                            >
                                Update
                            </Button>
                        </div>
                    </Form>
                </ModalContent>
            </Modal>
        );
    }
}

const mapDispatchToProps = {
    sendNotification: notify
};

export default connect(null, mapDispatchToProps)(UpdateUserCreditModal);
